// Lib
import { Capacitor } from '@capacitor/core';

import { registerMobilePushSubscription } from './mobileNotificationsService';
import { manuallyReportError } from '../../analytics/rollbarService';
import { NotificationData, NotificationsPlugin } from '../../../capacitor_plugins/notifications';

import { CAPACITOR_NOTIFICATIONS_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import { PUSH_NOTIFICATION_SUBSCRIPTION_TYPES } from '../../../common/notifications/pushNotificationConstants';

const getPushNotificationSubscriptionType = (platform: string) => {
    switch (platform) {
        case 'ios':
            return PUSH_NOTIFICATION_SUBSCRIPTION_TYPES.APNS;
        case 'android':
            return PUSH_NOTIFICATION_SUBSCRIPTION_TYPES.FCM;
        default:
            return PUSH_NOTIFICATION_SUBSCRIPTION_TYPES.WEB;
    }
};

export const askPushNotificationsPermissionsIfNeeded = async () => {
    if (!Capacitor.isPluginAvailable(CAPACITOR_NOTIFICATIONS_PLUGIN)) return;

    NotificationsPlugin.registerPushNotificationsOnDevice();
};

export const addListenerForPushNotificationRegistration = async () => {
    if (!Capacitor.isPluginAvailable(CAPACITOR_NOTIFICATIONS_PLUGIN)) return;

    await NotificationsPlugin.addListener('registerToken', async (data: NotificationData) => {
        const capacitorPlatform = Capacitor.getPlatform();
        const pushNotificationSubscriptionType = getPushNotificationSubscriptionType(capacitorPlatform);

        try {
            await registerMobilePushSubscription(data.token, pushNotificationSubscriptionType);
            NotificationsPlugin.pushNotificationRegistrationSuccessful();
        } catch (err) {
            manuallyReportError({
                errorMessage: 'Failed to register for push notifications',
                error: err,
            });
        }
    });
};
